<template>
    <div class="project-description">
        <ProjectComponent :isCreate="true"></ProjectComponent>
    </div>
</template>

<script>
    import ProjectComponent from "./components/ProjectComponent";
    export default {
        name: "ProjectDescription",
        components: {
            ProjectComponent
        },
        data(){
            return {
            }
        }
    }
</script>

<style scoped>

</style>
